import { ThirdPartyMediatorService } from '../../third-party-mediator.service';

export class AbstractInterface {
  private static mediatorInstance: ThirdPartyMediatorService = null;

  static set mediator(instance: ThirdPartyMediatorService) {
    this.mediatorInstance = instance;
  }

  static get mediator(): ThirdPartyMediatorService {
    return this.mediatorInstance;
  }
}
